import React from "react";
import "../css/MissionTicker.css";

const MissionTicker = () => {
  const liveDonors = [
    { id: 1, icon: "▶", name: "Amit Sharma", amount: "₹500" },
    { id: 2, icon: "❤️", name: "Rahul Verma", amount: "₹2,000" },
    { id: 3, icon: "★", name: "Priya Singh", amount: "₹1,000" },
    { id: 4, icon: "▲", name: "Sameer Khan", amount: "₹250" },
    { id: 5, icon: "🔥", name: "Neha Gupta", amount: "₹1,500" },
    { id: 6, icon: "⚡", name: "Rohan Joshi", amount: "₹750" },
  ];

  return (
    <div className="mission-master-wrapper">
      {}
      <div className="mission-white-card">
        {}
        <div className="mission-tag-pill">OUR MISSION</div>

        {}
        <h2 className="mission-main-title">
          From Education to Transformation 🎓
        </h2>

        {}
        <p className="mission-description-text">
          Our school is not just a building, but a home for hopes. Through this
          fundraising, we want to provide our children with the resources that
          can turn their dreams into reality.
        </p>

        {}
        <div className="mission-highlights-grid">
          {}
          <div className="highlight-yellow-node">
            <h4>100% Transparency</h4>
            <p>
              Every penny you contribute goes directly towards our children's
              education.
            </p>
          </div>

          {}
          <div className="highlight-yellow-node">
            <h4>Large Impact</h4>
            <p>Construction of digital labs and a new library.</p>
          </div>
        </div>

        {}
        <div className="mission-action-row">
        <button className="global-btn">
  Support Us Today
</button>
        </div>
      </div>

      {}
      <div className="live-ticker-dark-bar">
        <div className="ticker-infinite-track">
          {}
          {liveDonors.map((donor) => (
            <div key={`set1-${donor.id}`} className="ticker-item-badge">
              <span className="ticker-icon-graphic">{donor.icon}</span>
              <p className="ticker-string-msg">
                <span className="donor-bold-name">{donor.name}</span> ne{" "}
                <span className="donor-gold-amount">{donor.amount}</span> donate
                kiye
              </p>
            </div>
          ))}

          {}
          {liveDonors.map((donor) => (
            <div key={`set2-${donor.id}`} className="ticker-item-badge">
              <span className="ticker-icon-graphic">{donor.icon}</span>
              <p className="ticker-string-msg">
                <span className="donor-bold-name">{donor.name}</span> ne{" "}
                <span className="donor-gold-amount">{donor.amount}</span> donate
                kiye
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MissionTicker;
